<template>
    <div class="container">
        <div class="filters-area">
            <label>Periodo: 
                <strong>{{ data.name }}</strong> 
                <strong v-if="filters.row_data.type === 'source'"> {{ data.row_data.date }}</strong> 
                <strong v-if="filters.row_data.type === 'month'"> {{ data.row_data.year }}</strong> 
            </label>
            <b-button
                class="ml-2"
                size="sm"
                variant="primary" 
                type="button" 
                @click="getComparative()">
                Comparar periodos
                <md-icon icon="compare_arrows"/>
            </b-button>
            <b-form class="mt-3">
                <b-form-row v-if="filters.row_data.type === 'year'">
                    <!-- Solo podemos comparar año con año, no con otro unidad de tiempo -->
                    <b-form-group 
                        class="col-md-4" 
                        label="Comparar con los siguientes años:">
                        <multiselect 
                            v-model="comparativeYears"
                            :options="optionsYears"
                            :multiple="true"
                            placeholder="Años para comparar"
                            track-by="value"
                            label="text">
                            <span slot="noResult">Oops! No se encontraron resultados.</span>
                            <template v-slot:clear >
                                <div class="multiselect__clear" @click="filters.zonesSelected = []"></div>
                            </template>
                        </multiselect>
                    </b-form-group>
                </b-form-row>

                <b-form-row v-else>
                    <!-- Solo podemos comparar dia con otros dias -->
                    <Filters ref="filters" :row-data="filters.row_data" :source-criteria="filters.sourceCriteria"/>
                </b-form-row>
            </b-form>
        </div>

        <div v-if="loading" class="col-12 text-center pt-5">
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
            <div class="text-muted">Comparando ..</div>
        </div>
        <b-row class="comparation-card my-3" v-if="!loading">
            <b-col lg="12" v-for="(row, index) in comparations" :key="index">
                <b-tabs>
                    <b-tab title="Tabla" active>
                        <b-row class="my-3 mx-1">
                            <b-col lg="8">
                                <b-table
                                    show-empty
                                    hover
                                    small
                                    bordered
                                    stacked-sm
                                    responsive
                                    striped
                                    head-variant="light"
                                    :items="row.rows" 
                                    :fields="row.headers"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :id="'comparative-table-'+index">

                                    <!-- A custom formatted header cell for field 'data_1' -->
                                    <template #head(data_1)="data">
                                        <div class="text-right">{{ data.label }}</div>
                                    </template>

                                    <!-- A custom formatted header cell for field 'data_2' -->
                                    <template #head(data_2)="data">
                                        <div class="text-right">
                                            <md-icon 
                                                icon="star"
                                                class="text-warning font-weight-bolder"
                                                style="font-size: 12px; padding-bottom: 2px;"
                                                v-if="true"/>
                                            {{ data.label }}
                                        </div>
                                    </template>

                                    <!-- A custom formatted header cell for field 'diff' -->
                                    <template #head(diff)="data">
                                        <div class="text-right">{{ data.label }}</div>
                                    </template>

                                    <template #cell(field)="data">
                                        <strong>{{ data.item.field }}</strong>
                                    </template>

                                    <template #cell(data_1)="data">
                                        <div class="text-right">
                                            <span v-if="data.item.field == 'Rides' || data.item.field == 'SPIT Rides'">{{ data.item.data_1 }}</span>
                                            <span v-else>${{ number_format(data.item.data_1,2,'.',',') }}</span>
                                            <md-icon 
                                                icon="arrow_upward"
                                                class="text-success font-weight-bolder"
                                                v-if="data.item.data_1 > data.item.data_2"/>
                                            <md-icon v-else
                                                icon="keyboard_double_arrow_down"
                                                class="text-danger font-weight-bolder"/>
                                        </div>
                                    </template>

                                    <template #cell(data_2)="data">
                                        <div class="text-right">
                                            <span v-if="data.item.field == 'Rides' || data.item.field == 'SPIT Rides'">{{ data.item.data_2 }}</span>
                                            <span v-else>${{ number_format(data.item.data_2,2,'.',',') }}</span>
                                        </div>
                                    </template>

                                    <template #cell(diff)="data">
                                        <div class="text-right" v-if="data.item.diff != ''">
                                            <span v-if="data.item.field == 'Rides' || data.item.field == 'SPIT Rides'">{{ data.item.diff }}</span>
                                            <span v-else>${{ number_format(data.item.diff,2,'.',',') }}</span>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                            <b-col lg="4">
                                <div class="d-flex justify-content-between">
                                    <div class="text-muted">Moneda:</div>
                                    <strong>{{ row.metrics.currency }}</strong>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="text-muted">Margen de ganancia: 
                                        <strong>{{ row.metrics.row_data.year }}</strong>
                                    </div>
                                    <strong :class="getTextColorPercentage(row.metrics.margin_profit)">
                                        {{ number_format(row.metrics.margin_profit,2,'.') }}%
                                    </strong>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div class="text-muted">Margen de ganancia: 
                                        <strong>{{ row.metrics.last_year }}</strong>
                                    </div>
                                    <strong :class="getTextColorPercentage(row.metrics.last_margin_profit)">
                                        {{ number_format(row.metrics.last_margin_profit,2,'.') }}%
                                    </strong>
                                </div>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab title="Grafica" @click="getDataTimeLine(row, index)">
                        <b-row class="mb-4">
                            <b-col lg="6" v-for="(row2, index2) in chartData[index] || []" :key="index2">
                                <TimeLineChart :data="row2 || {}"></TimeLineChart>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import api from "../../../../api.js";
    import moment from 'moment'
    import Filters from './helpers/ComparativeFilters.vue'
    import TimeLineChart from './TimeLineChart.vue';

    export default {
        name: "Comparative",
        components:{ Multiselect, Filters, TimeLineChart },
        props: {
            data: {
                type : Object,
                required: true,
                default: null
            },
            filters: {
                type : Object,
                required: true,
                default: null
            }
        },
        data() {
            return {
                codeReport: 'spit-revenue',
                sortBy: 'index',
                sortDesc: true,
                loading: false,
                showHtmlTable: false,
                comparations: [],
                comparativeYears: [],
                chartData: []
            }
        },
        methods: {
            getComparative() {
                this.loading = true
                let comparatives = []

                const row_type = this.filters.row_data.type
                if (row_type == 'year') {
                    // to compare years with years
                    this.comparativeYears.forEach(element => {
                        comparatives.push({date: element.value, year: element.value, type: row_type})
                    });
                }

                // to campare days with days
                if (row_type == 'day') {
                    const comparativeDates = this.$refs.filters.form
                    comparativeDates.forEach(element => {
                        comparatives.push({date: element.date, type: row_type})
                    });
                }

                // to campare days with weeks
                if (row_type == 'week' || row_type == 'month') {
                    const comparativeDates = this.$refs.filters.form
                    comparativeDates.forEach(element => {
                        comparatives.push({date: element.date, year: element.year, type: row_type})
                    });
                }

                if (row_type == 'source') {
                    const comparativeDates = this.$refs.filters.form
                    comparativeDates.forEach(element => {
                        comparatives.push({
                            date: element.date, 
                            year: element.year,
                            parent: this.filters.row_data.parent,
                            type: row_type,
                            sourceCriteria: this.filters.sourceCriteria,
                            source_id: element.source.value,
                            source: element.source.text
                        })
                    });
                }

                this.filters.comparative = comparatives

                api(this)
                    .get("spit/comparative", {params: {filters: this.filters}})
                    .then(res => {
                        this.comparations = res.data 
                    })
                    .catch(error => { 
                        this.$root.handleRequestError(error) 
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            number_format (number, decimals, dec_point, thousands_sep) {
                // Strip all characters but numerical ones.
                number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number,
                prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s     = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
                
                // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
                }

                if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
                }

                return s.join(dec);
            },
            getTextColorPercentage(quantity) {
                let variant = ''
                if (quantity >= 20) {
                    variant = 'text-success font-weight-bold'
                } else {
                    variant = 'text-warning font-weight-bold'
                }

                return variant + ' text-right'
            },
            async getDataTimeLine(data, index) {
                let filters      = { ...this.filters };
                //filters.row_data = data.metrics.row_data
                filters.compare  = data.comparative
                filters.chart    = 'timeLine'
                this.loadingRidesTimeLine = true; // Opcional: indica carga

                try {
                    const res = await api(this).get("spit/timelines", {
                        params: { filters },
                    });
                    this.$set(this.chartData, index, res.data);
                } catch (error) {
                    this.$root.handleRequestError(error);
                    this.$set(this.chartData, index, {});
                } finally {
                    this.loadingRidesTimeLine = false;
                }
            },
        },
        computed: {
            optionsYears() {
                const startYear = 2020
                const limit     = moment().format('YYYY')
                let optionsYears = []
                for (let index = limit; index >= (startYear); index--) {
                    optionsYears.push({value: index, text: index})
                }

                return optionsYears
            },
        }
    }
</script>